import React, { Component } from 'react';
import logo from './../../assets/logo.png';
//import fundo from './../../../assets/fundo.jpeg';
// import { Container } from './styles';

import { setPedidoA } from './../../redux/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import InstagramIcon from '@material-ui/icons/Instagram';
import WhatsAppIcon from '@material-ui/icons/WhatsApp';
import FacebookIcon from '@material-ui/icons/Facebook';

class Inicial extends Component {
  state = {
    colorHeader: "#991e25"
  }

  async componentDidMount() {
    console.log('Teste', this.props.location.state.servico)
    console.log('Teste3', this.props.pedidoA.pedidoA)
  }
  render() {
    const aberto = this.props.location.state.servico === '5';
    return (
      <div style={{
        minHeight: '100vh',
        width: '100%',
        background: 'linear-gradient(180deg, #fff8f3 0%, #fff 100%)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: 'Montserrat, Roboto, Arial, sans-serif',
      }}>
        {/* Logo centralizado */}
        <div style={{ marginTop: 40, marginBottom: 16, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <img src={logo} alt="Casa da Pizza" style={{
            width: 170,
            height: 170,
            borderRadius: 24,
            boxShadow: '0 4px 24px #a52a2a22',
            background: '#fff',
            marginBottom: 8
          }} />
        </div>

        {/* Botões modernos */}
        <div style={{ width: '100%', maxWidth: 320, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16 }}>
          <button
            style={{
              width: '100%',
              background: '#991e25',
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              fontSize: 18,
              fontWeight: 600,
              padding: '14px 0',
              marginBottom: 4,
              cursor: 'pointer',
              boxShadow: '0 2px 8px #991e2511',
              transition: 'background 0.2s',
            }}
            onClick={() => {
              this.props.history.push({
                pathname: '/Main',
                state: { pedidos: 0 }
              })
            }}
            onMouseOver={e => e.currentTarget.style.background = '#b32a2a'}
            onMouseOut={e => e.currentTarget.style.background = '#991e25'}
          >
            Fazer um pedido
          </button>
          <button
            style={{
              width: '100%',
              background: '#991e25',
              color: '#fff',
              border: 'none',
              borderRadius: 12,
              fontSize: 18,
              fontWeight: 600,
              padding: '14px 0',
              marginBottom: 4,
              cursor: 'pointer',
              boxShadow: '0 2px 8px #991e2511',
              transition: 'background 0.2s',
            }}
            onClick={() => {
              this.props.history.push({
                pathname: '/Pedidos',
                state: { pedidos: 0 }
              })
            }}
            onMouseOver={e => e.currentTarget.style.background = '#b32a2a'}
            onMouseOut={e => e.currentTarget.style.background = '#991e25'}
          >
            Meus pedidos
          </button>
        </div>

        {/* Ícones sociais modernos */}
        <div style={{ display: 'flex', marginTop: 40, gap: 28, justifyContent: 'center' }}>
          <a
            href="https://www.instagram.com/zekazen/"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px #991e2511',
              transition: 'box-shadow 0.2s',
              cursor: 'pointer',
            }}
            onMouseOver={e => e.currentTarget.style.boxShadow = '0 4px 16px #991e2522'}
            onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 8px #991e2511'}
          >
            <InstagramIcon style={{ fontSize: 32, color: '#991e25' }} />
          </a>
          <a
            href="https://api.whatsapp.com/send?phone=5581998297669"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px #991e2511',
              transition: 'box-shadow 0.2s',
              cursor: 'pointer',
            }}
            onMouseOver={e => e.currentTarget.style.boxShadow = '0 4px 16px #991e2522'}
            onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 8px #991e2511'}
          >
            <WhatsAppIcon style={{ fontSize: 32, color: '#991e25' }} />
          </a>
          <a
            href="https://www.facebook.com/zekazen"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              width: 48,
              height: 48,
              borderRadius: '50%',
              background: '#fff',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 8px #991e2511',
              transition: 'box-shadow 0.2s',
              cursor: 'pointer',
            }}
            onMouseOver={e => e.currentTarget.style.boxShadow = '0 4px 16px #991e2522'}
            onMouseOut={e => e.currentTarget.style.boxShadow = '0 2px 8px #991e2511'}
          >
            <FacebookIcon style={{ fontSize: 32, color: '#991e25' }} />
          </a>
        </div>

        {/* Mensagem de status */}
        <div style={{ marginTop: 36, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
          {aberto ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 22, color: 'green', fontWeight: 'bold' }}>🟢 Estamos abertos</span>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
              <span style={{ fontSize: 22, color: 'red', fontWeight: 'bold' }}>🔴 Estamos fechados</span>
            </div>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = store => ({
  pedidoA: store.PedidoAReducer
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ setPedidoA }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Inicial);
